module.exports = __webpack_public_path__ + "static/media/cover-pic.86251fd3.jpg";